import { ExternalLinkIcon } from "@chakra-ui/icons";

import { MdRoom, MdCalendarMonth } from "react-icons/md";
import {
  Box,
  Center,
  Divider,
  Flex,
  Heading,
  Link,
  ListItem,
  Stack,
  Text,
  Icon,
  UnorderedList,
  Image,
} from "@chakra-ui/react";
import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBriefcase,
  faSchool,
  faStar,
} from "@fortawesome/free-solid-svg-icons";

import { MdWork,MdSchool } from "react-icons/md";
function Work(props) {

  let workIconStyles = { background: "#EDAC33" };

  const workIcon = {
    icon: <FontAwesomeIcon icon={faBriefcase} />,
    iconStyle: { background: "rgb(33, 150, 243)", color: "#fff" },
  };
  const schoolIcon = {
    icon: <FontAwesomeIcon icon={faSchool} />,
    iconStyle: { background: "rgb(233, 30, 99)", color: "#fff" },
  };
  const starIcon = {
    icon: <FontAwesomeIcon icon={faStar} />,
    iconStyle: { background: "rgb(16, 204, 82)", color: "#fff" },
  };
  return (
    <Box w={{ base: "95%", md: "80%" }} margin={"auto"}
    padding='5%'
    border={'solid #ffd3366b'}
    borderRadius='40px'
    id="experience"
    
    >
      <Box textAlign={"left"} w="100%" margin={"auto"}>
        <Heading textAlign={"center"} fontSize={30} color={"cpdark"} mb={10}>
          Where I've Worked & Studied
        </Heading>
       
        <VerticalTimeline>
        <VerticalTimelineElement 
           
           contentStyle={{ background: "#14213f", color: "#ffffff" }}
           contentArrowStyle={{ borderRight: "7px solid #ffffff" }}
           className="vertical-timeline-element--work"
           date="April 2019 - Present"
           dateClassName="date"
           iconStyle={workIconStyles}
          icon={
           <Box
             display="flex"
             justifyContent={"center"}
             alignItems="center"
             padding={2}
             transition={"all 0.3s ease-out"}
           >
             <Image
               src={'images/work.png'}
               alt="SUHAIL K"
               fallbackSrc="https://via.placeholder.com/150"
               objectFit={"fill"}
             ></Image>
           </Box>
         }
         >
            <Stack textColor={"cplite"} textAlign={"left"}>
              <h1>IT Administrator & Android Developer</h1>
              <Link
                fontSize="16px"
                fontWeight={600}
                href="https://www.mtckerala.com/"
                isExternal
              >
                Yusuf Malabar Trading LLP <ExternalLinkIcon mx="2px" />
              </Link>
            </Stack>

            <UnorderedList textAlign={"left"}>
              <ListItem>
                IT Administrator with 4+ years of experience managing complex
                computer systems and networks for a large organization.
              </ListItem>
              <ListItem>
                Skilled in network administration, system maintenance, and
                database management.
              </ListItem>
              <ListItem>
                Excellent communicator and team player, with a proven ability to
                troubleshoot complex IT problems and provide innovative
                solutions.
              </ListItem>
              <ListItem>
                Developed an Android application for inventory and billing
                management, using Java, Android SDK (Android Studio), and MS
                SQL. The application provided inventory tracking, order
                management, billing, and reporting features. Playstore link
              </ListItem>
            </UnorderedList>
          </VerticalTimelineElement>
          <VerticalTimelineElement 
           
            contentStyle={{ background: "#14213f", color: "#ffffff" }}
            contentArrowStyle={{ borderRight: "7px solid #ffffff" }}
            className="vertical-timeline-element--work"
            date="April 2022 - Present"
            dateClassName="date"
            iconStyle={workIconStyles}
           icon={
            <Box
              display="flex"
              justifyContent={"center"}
              alignItems="center"
              padding={2}
              transition={"all 0.3s ease-out"}
            >
              <Image
                src={'images/school.png'}
                alt="SUHAIL K"
                fallbackSrc="https://via.placeholder.com/150"
                objectFit={"fill"}
              ></Image>
            </Box>
          }
          >
            <Stack textAlign={"left"} textColor={"cplite"}>
              <h1>Full Stack Web Develeopment</h1>
              <Link
                className="vertical-timeline-element-subtitle"
                fontSize="16px"
                fontWeight={600}
                href="https://masaischool.com/"
                isExternal
              >
                Masai School, Banglore <ExternalLinkIcon mx="2px" />
              </Link>
            </Stack>

            <UnorderedList textAlign={"left"}>
              <ListItem>
                Completed 35-week MERN Stack Development and DSA Bootcamp.
                Acquired handson experience in full-stack web development and
                honed problem-solving skills
              </ListItem>
            </UnorderedList>
          </VerticalTimelineElement>
        </VerticalTimeline>
      </Box>
    </Box>
  );
}

export default Work;
